import './autocomplete';
import {initializationForms} from  './feedback'
import MmenuLight from 'mmenu-light';
import { Fancybox } from "@fancyapps/ui";

/** 
 * Fix safari ios15 height
 */
document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);

document.addEventListener(
  "DOMContentLoaded", () => {
    
    /**
     * Mobile menu 
     */
    const menu = new MmenuLight(
      document.querySelector('#menu'),
      '(max-width: 768px)'
    );

    const navigator = menu.navigation();
    const drawer = menu.offcanvas();

    document.querySelector('#showMenuButton').addEventListener('click', function(e) {
      e.preventDefault();
      
      if (this.classList.contains('_opened')) {
        this.classList.remove('_opened');
        drawer.close();
      }
      else {
        this.classList.add('_opened');
        drawer.open();
      }
    });
    
    /**
     * Desktop menu
     */
    document.querySelectorAll('span.menu__item').forEach(function(el) {
      el.addEventListener('click', function(e) {
          e.preventDefault();
          el.parentElement.classList.toggle('_opened');
        });
    });
    
    /**
     * Search form
     */
    document.querySelector('#showSearchForm').addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      document.querySelector('#searchForm').classList.toggle('_visible');
    });
    
    /**
     * Close menu and search form by click
     */
    document.addEventListener('click', function(e) {
      
      // close menu
      const menuOpened = document.querySelector('#menu li._opened');
      if (menuOpened) menuOpened.classList.remove('_opened');
      
      // close search form
      if (!e.target.closest('#searchForm')) {
        document.querySelector('#searchForm').classList.remove('_visible');
      }
    });
  }
);

/** 
 * Fancybox
 */
Fancybox.bind('[data-fancybox]', {
  compact: true,
  Toolbar: {
    display: {
      left: [],
      middle: [],
      right: [],
    },
  },
});

Fancybox.bind('#showPhones', {
  compact: true,
  defaultType: 'inline',
  mainClass: 'fancybox-top',
});

Fancybox.bind('#showCallbackForm', {
  compact: true,
  defaultType: 'inline',
});

Fancybox.bind('#showFilter', {
  compact: true,
  defaultType: 'inline',
  mainClass: 'fancybox-filter',
});

document.addEventListener("DOMContentLoaded", () => {
    initializationForms()
})